import {
  AttachFileOutlined,
  CloseRounded,
  FileUploadOutlined,
  FileUploadRounded,
} from "@mui/icons-material";
import { Box, Button, IconButton } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { isEmpty, size } from "lodash";
import { useCallback, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { columnTypesDate } from "../../../_src_shared/utils/agGrid/columnTypes/columnTypesDate";
import { columnTypesNumber } from "../../../_src_shared/utils/agGrid/columnTypes/columnTypesNumber";
import { useLoanFilesHook } from "../../../hooks/useLoanFilesHook";
import { loanDrilldownSet } from "../../../redux/actions/loanDrilldownActions";
import AgGridTableWrapper from "../../agGrid/AgGridTableWrapper";
import FileUploadField from "../../inputs/FileUploadField";
import Flx from "../../layout/Flx";
import BasicModal from "../BasicModal";

const UploadLoanFileModal = ({
  show,
  loading,
  onClose,
  docType,
  docGroup,
  onFileUploadSuccess,
}) => {
  // const modal = useSelector((state) => state?.modal);
  // const { modalType, modalData, modalState } = modal;
  // const dispatch = useDispatch();
  // const docGroup = modalData?.docGroup;
  // const docType = modalData?.docType;

  const onClear = () => {
    onClose(false);
    // dispatch(modalClose());
    return;
  };

  return (
    <BasicModal
      show={show}
      title={`Upload ${docType || ""}`}
      // title={`Upload File - ${modalState?.docType || ""}`}
      maxWidth="sm"
      icon={<FileUploadOutlined />}
      allowFullScreen
      onClose={onClear}
      // open={modalType === modalTypeName}
    >
      <UploadFileContent
        docType={docType}
        altLoading={loading}
        docGroup={docGroup}
        onUploadSuccess={(d, uploadedDocuments) => {
          if (onFileUploadSuccess) {
            onFileUploadSuccess(d, uploadedDocuments);
            return;
          }
          onClear();
        }}
      />
    </BasicModal>
  );
};

const UploadFileContent = ({
  docType,
  docGroup,
  onUploadSuccess,
  altLoading,
}) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const [files, setFiles] = useState(null);
  const { loading, uploadLoanDocs } = useLoanFilesHook();
  const dispatch = useDispatch();
  // const { loading, uploadProfileDocuments } = useEndpointHook();
  // const dispatch = useDispatch();

  const updateFilesMetadata = (files, docGroup, docType) => {
    // Guard clause for empty files array
    if (!files || files.length === 0) {
      return [];
    }

    // Create a new array with updated metadata
    return files.map((file) => {
      // Create a copy of the file to avoid mutating the original
      const updatedFile = { ...file };

      // Update docGroup if provided
      if (docGroup !== undefined && docGroup !== null) {
        updatedFile.docGroup = docGroup;

        // Clear docType if docGroup changes and the types don't match
        // This assumes docType is dependent on docGroup
        if (updatedFile.docType && docType === undefined) {
          updatedFile.docType = undefined;
        }
      }

      // Update docType if provided
      if (docType !== undefined && docType !== null) {
        updatedFile.docType = docType;
      }

      return updatedFile;
    });
  };

  const onFilesAdded = useCallback(
    (newFiles, docGroup, docType) => {
      let updatedFiles = updateFilesMetadata(newFiles, docGroup, docType);
      if (isEmpty(files)) {
        setFiles(updatedFiles);
        return;
      }

      setFiles([...files, ...updatedFiles]);
    },
    [files]
  );

  const handleUploadFiles = useCallback(() => {
    // onUploadSuccess(loanDrilldown, [
    //   // {
    //   //   _id: "6952da5791d1559c9abdf83c",
    //   //   isHidden: null,
    //   //   isFinal: false,
    //   //   documentStatus: "New Upload",
    //   //   parsed: "False",
    //   //   searchIndexed: "False",
    //   //   containerName: "687e3b45138dca9647e7ffb1",
    //   //   docGroup: "Borrower Documents",
    //   //   docType: "Loan Application",
    //   //   file_name_as_loaded: "SampleJPGImage_500kbmb.jpg",
    //   //   file_display_name: "loan app test - joe.jpg",
    //   //   file_storage_name: "ed0e9b16-e4ee-11f0-a1e1-f6e7c6008a07.jpg",
    //   //   content_type: "image/jpeg",
    //   //   size: 512017,
    //   //   uploadedBy: "dev2@arrowservicing.com",
    //   //   uploadDate: "2025-12-29T19:45:27.899101",
    //   //   modifiedDate: "2025-12-29T19:45:28",
    //   //   unique_id: null,
    //   //   dealId: "687e3b45138dca9647e7ffb1",
    //   //   name: "SampleJPGImage_500kbmb.jpg",
    //   //   file_extension: "jpg",
    //   // },
    //   {
    //     id: "57579d81-e085-45ca-8ed4-a11fc533c224",
    //     name: "SampleJPGImage_500kbmb.jpg",
    //     file_display_name: "loan app test - joe.jpg",
    //     docGroup: "Borrower Documents",
    //     docType: "Loan Application",
    //   },
    //   {
    //     id: "e516eb64-99a5-4569-a4c3-40ae897b4901",
    //     name: "drivers license front.jpg",
    //     file_display_name: "Photo ID - Joe.jpg",
    //     docGroup: "Borrower Documents",
    //     docType: "Photo Identification",
    //   },
    // ]);
    // // onUploadSuccess(loanDrilldown, files);
    // return;
    uploadLoanDocs({
      loanId: loanDrilldown?._id,
      files: files,
      onSuccessMsg:
        size(files) > 1
          ? `${size(files)} files uploaded successfully`
          : "File uploaded successfully",
      onSuccessFn: (data) => {
        // if (onUploadSuccess) {
        //   onUploadSuccess(data);
        //   return;
        // }
        dispatch(loanDrilldownSet(data));
        onUploadSuccess(data, files);
      },
    });
  }, [files, onUploadSuccess, loanDrilldown]);

  return (
    <>
      <FileUploadField
        key={`${docType}-initial-upload`}
        id={`${docType}-initial-file-upload`}
        suppressUploadButton
        borderSize={1.5}
        docGroup={docGroup}
        docType={docType}
        hideFileList
        onFilesAdded={onFilesAdded}
      />
      <UploadedFilesTable files={files} setFiles={setFiles} />
      {isEmpty(files) ? null : (
        <Flx
          g={1}
          fw
          ac
          end
          wrap
          sx={{
            mt: 4,
          }}
        >
          <Button
            onClick={() => setFiles(null)}
            variant="outlined"
            size="large"
            color="primary"
          >
            Cancel
          </Button>

          <Button
            loading={altLoading || loading}
            onClick={handleUploadFiles}
            startIcon={
              <FileUploadRounded
                className="thin"
                sx={{ fontSize: "16px !important" }}
              />
            }
            size="large"
            color="primary"
          >
            Upload Files ({size(files)})
          </Button>
        </Flx>
      )}
    </>
  );
};

const UploadedFilesTable = ({ files, setFiles }) => {
  const ref = useRef();

  const modalContentRef = useRef(null);

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Filename",
        field: "file_display_name",
        flex: 1,
        minWidth: 250,
        cellEditor: "agTextCellEditor",
        editable: true,
        // checkbox: true,
        cellStyle: { display: "flex", alignItems: "center", gap: "6px" },
        cellRenderer: (params) => {
          // console.log("params", params);
          return (
            <>
              <AttachFileOutlined
                className="thin"
                sx={{ fontSize: 16 }}
                // contentType={params?.value?.content_type}
              />
              {/* <FilePreviewImageTypeIcon
                size={18}
                contentType={params?.value?.content_type}
              /> */}
              {params.value}
            </>
          );
        },
      },
      // {
      //   headerName: "Document Group",
      //   field: "docGroup",
      //   editable: true,
      //   width: 220,
      //   cellEditor: "agRichSelectCellEditor",
      //   cellEditorPopup: true,
      //   cellEditorParams: {
      //     values: fileDocGroups || [],
      //   },
      // },
      // {
      //   headerName: "Document Type",
      //   field: "docType",
      //   editable: true,
      //   width: 220,
      //   cellEditor: "agRichSelectCellEditor",
      //   cellEditorPopup: true,
      //   cellEditorParams: (params) => {
      //     return {
      //       values: getDocTypesByGroup(params.data.docGroup || "Appraisal"),
      //     };
      //   },
      // },
      {
        width: 42,
        cellStyle: {
          paddingRight: 0,
          paddingLeft: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        field: "delete",
        cellRenderer: (params) => {
          return (
            <IconButton sx={{ p: 0.4 }} size="small">
              <CloseRounded className="thin" />
            </IconButton>
          );
        },
      },
    ],
    []
  );

  const handleCellValueChanged = useCallback(
    (params) => {
      const { colDef, data, newValue } = params;

      // Create a copy of the data to update
      const updatedData = { ...data };

      // If the user changes the filename
      if (colDef.field === "file_display_name") {
        const originalExtension = data.name.split(".").pop().toLowerCase();
        const newValueWithoutExt = newValue.replace(/\.[^/.]+$/, "");
        updatedData.file_display_name = `${newValueWithoutExt}.${originalExtension}`;
      }

      // If the user changes docGroup
      if (colDef.field === "docGroup") {
        updatedData.docGroup = newValue;
        // Clear docType when docGroup changes
        updatedData.docType = "";
      }

      // If the user changes docType
      if (colDef.field === "docType") {
        updatedData.docType = newValue;
      }

      // Update the parent files state
      setFiles((prev) =>
        prev.map((item) => (item.id === data.id ? updatedData : item))
      );

      setTimeout(() => {
        if (ref.current && ref.current.api) {
          ref.current.api.refreshCells();
        }
      }, 0);
    },
    [setFiles]
  );

  const onCellClicked = useCallback(
    (params) => {
      const { colDef, data } = params;

      if (colDef.field === "delete") {
        setFiles((prev) => prev.filter((item) => item.id !== data.id));
      }
    },
    [setFiles]
  );

  const columnTypes = useMemo(() => {
    return {
      ...columnTypesDate(),
      ...columnTypesNumber(),
    };
  }, []);

  if (isEmpty(files)) {
    return null;
  }

  return (
    <Box>
      <AgGridTableWrapper simpleTable suppressMinHeightWhenPopulated={files}>
        <AgGridReact
          ref={ref}
          rowData={files}
          columnDefs={columnDefs}
          singleClickEdit
          onCellClicked={onCellClicked}
          columnTypes={columnTypes}
          domLayout={"autoHeight"}
          headerHeight={0}
          onCellValueChanged={handleCellValueChanged}
          stopEditingWhenCellsLoseFocus
          popupParent={modalContentRef.current}
          // getRowId={(params) => params.data.id}
          // onSelectionChanged={handleRowSelectionChange}
          // rowSelection={{
          //   mode: "multiRow",
          // }}
        />
      </AgGridTableWrapper>
    </Box>
  );
};

export default UploadLoanFileModal;
